export default {
    'name': 'abst',
    'label': 'patent-view.ABST',
    'getComponent': () => import('./abst.vue'),
    'tabIndex': 0,
    'left': true,
    'right': true,
    'singleView': true,
    'compareView': true,
    'exclusiveRoutePath': '/abst',
    'enableDensity': false,
};
